import { Environment, OrbitControls, useGLTF } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
// import { Bloom, EffectComposer, Vignette } from '@react-three/postprocessing';
import { useEffect, useRef } from 'react';
import { ROOT_MEDIA } from 'shared-base';
import { CameraAnimation } from './Three.camera';
import { Wrapper } from './Three.style';

const Model = (props: any) => {
  const { glb } = props;
  const { model: scene } = useGLTF(`${ROOT_MEDIA}/glbs/${glb}`);
  return <primitive object={scene} scale={1} />;
};

export type ThreeProps = {
  animationState: IAnimationState;
  callbacks: {
    onLoad: () => void;
  };
};

export function ThreeInner(props: ThreeProps) {
  const orbitRef = useRef<any>();

  useEffect(() => {
    if (orbitRef.current) {
      // Set the OrbitControls target to a specific height
      orbitRef.current.target.set(0, 2, 0); // Focus at (0, 5, 0)
      orbitRef.current.update(); // Ensure the changes take effect
    }
  }, []);

  return (
    <>
      <ambientLight intensity={0.5} />
      <directionalLight position={[10, 10, 5]} intensity={1} />
      <pointLight position={[-10, -10, -10]} intensity={0.8} />
      <CameraAnimation />
      <Environment preset='dawn' background={false} />
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} intensity={1} />
      <OrbitControls ref={orbitRef} />
      <Model glb='space.glb' />
    </>
  );
}

export function Three(props: ThreeProps) {
  const { animationState, callbacks } = props;

  return (
    <Wrapper className='Three-wrapper' data-testid='Three-wrapper'>
      <Canvas>
        <ThreeInner {...props} />
      </Canvas>
    </Wrapper>
  );
}

export default Three;
